import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Usage } from '../../models/main';

type ExtraStatKey = 'documents' | 'iaExtraction' | 'invites' | 'edocs';

const EXTRA_STAT_ICONS: Record<ExtraStatKey, string> = {
  documents: 'receipt',
  iaExtraction: 'magic',
  invites: 'invite',
  edocs: 'edoc',
};

@Component({
  selector: 'app-usage-card',
  templateUrl: './usage-card.component.html',
  styleUrls: ['./usage-card.component.scss'],
})
export class UsageCardComponent implements OnInit {
  @Input() type!: string;
  @Input() data!: Usage;
  title!: string;
  icon!: string;
  date!: Date;
  value!: string | undefined;
  unit = '';

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.date = new Date(Number(this.data.year), Number(this.data.month) - 1, 1);

    switch (this.type) {
      case 'recordsMonth':
        this.title = this.translate.instant('usageCard.recordsMonth', {
          monthYear: this.translate.instant('organizationUsage.months.' + this.data.month) + ' ' + this.data.year,
        });
        this.icon = 'file-text';
        this.value = this.data.products.records.period;
        break;
      case 'records':
        this.title = this.translate.instant('usageCard.records');
        this.icon = 'copy';
        this.value = this.data.products.records.total;
        break;
      case 'users':
        this.title = this.translate.instant('usageCard.users');
        this.icon = 'users';
        this.value = this.data.products.members.total;
        break;
      case 'storage':
        this.title = this.translate.instant('usageCard.storage');
        this.icon = 'save';
        this.value = this.data.products.storage.total;
        this.unit = 'GB';
        break;
      default:
        if (this.type in EXTRA_STAT_ICONS) {
          const key = this.type as ExtraStatKey;
          this.title = this.translate.instant('usageCard.' + key);
          this.icon = EXTRA_STAT_ICONS[key];
          this.value = this.data.extraStats?.[key]?.toString();
        }
    }
  }
}
